var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_26035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357422,
    y: 0.241211,
    width: 21,
    height: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_26035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8574 14.241C11.9512 14.241 12.8809 13.8582 13.6465 13.0925C14.4121 12.3269 14.7949 11.3972 14.7949 10.3035C14.7949 9.20972 14.4121 8.28003 13.6465 7.5144C12.8809 6.74878 11.9512 6.36597 10.8574 6.36597C9.76367 6.36597 8.83398 6.74878 8.06836 7.5144C7.30273 8.28003 6.91992 9.20972 6.91992 10.3035C6.91992 11.3972 7.30273 12.3269 8.06836 13.0925C8.83398 13.8582 9.76367 14.241 10.8574 14.241ZM10.8574 12.666C10.2012 12.666 9.64336 12.4363 9.18398 11.9769C8.72461 11.5175 8.49492 10.9597 8.49492 10.3035C8.49492 9.64722 8.72461 9.0894 9.18398 8.63003C9.64336 8.17065 10.2012 7.94097 10.8574 7.94097C11.5137 7.94097 12.0715 8.17065 12.5309 8.63003C12.9902 9.0894 13.2199 9.64722 13.2199 10.3035C13.2199 10.9597 12.9902 11.5175 12.5309 11.9769C12.0715 12.4363 11.5137 12.666 10.8574 12.666ZM10.8574 16.866C8.72826 16.866 6.78867 16.2717 5.03867 15.0832C3.28867 13.8946 2.01992 12.3014 1.23242 10.3035C2.01992 8.30555 3.28867 6.71232 5.03867 5.52378C6.78867 4.33524 8.72826 3.74097 10.8574 3.74097C12.9866 3.74097 14.9262 4.33524 16.6762 5.52378C18.4262 6.71232 19.6949 8.30555 20.4824 10.3035C19.6949 12.3014 18.4262 13.8946 16.6762 15.0832C14.9262 16.2717 12.9866 16.866 10.8574 16.866ZM10.8574 15.116C12.5053 15.116 14.0184 14.6821 15.3965 13.8144C16.7746 12.9467 17.8283 11.7764 18.5574 10.3035C17.8283 8.83055 16.7746 7.66024 15.3965 6.79253C14.0184 5.92482 12.5053 5.49097 10.8574 5.49097C9.20951 5.49097 7.69648 5.92482 6.31836 6.79253C4.94023 7.66024 3.88659 8.83055 3.15742 10.3035C3.88659 11.7764 4.94023 12.9467 6.31836 13.8144C7.69648 14.6821 9.20951 15.116 10.8574 15.116Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconBlack);
export default __webpack_public_path__ + "static/media/eye-icon-black.082cf553cff32351eb1466e81d39f377.svg";
export { ForwardRef as ReactComponent };